import { fontFamilies } from "../utils/fontFamilies";
import { textPositions } from "../utils/textPositions";

export const createApplicationOneSlice = (set) => ({
  xCols: [15,35,35,15],
  yRows: [15,35,35,15],
  textTop: "SUPERMARKET",
  textBottom: "FLEXIBLE VISUAL SYSTEMS",
  textColor: "color1",
  textBGColor: "color8",
  textBGActive: true,
  background: "color8",
  fontFamily: fontFamilies[2],
  textPosition: textPositions[0],
  hiddenRepetitions: [],
  animation: 'noAnimation',
  setTextPosition: (value) => set({ textPosition: value }),
  setFontFamily: (value) => set({ fontFamily: value }),
  setTextBGColor: (value) => set({ textBGColor: value }),
  setTextBGActive: (value) => set({ textBGActive: value }),
  setTextColor: (value) => set({ textColor: value }),
  setBackground: (value) => set({ background: value }),
  setTextTop: (value) => set({ textTop: value }),
  setTextBottom: (value) => set({ textBottom: value }),
  setX: (value) => set({ x: value }),
  setY: (value) => set({ y: value }),
  setXCols: (value) => set({ xCols: value }),
  setYRows: (value) => set({ yRows: value }),
  setHiddenRepetitions: (value) => set({ hiddenRepetitions: value }),
  setAnimation: (value) => set({ animation: value }),
});
